import { render, staticRenderFns } from "./NewYearVideo.vue?vue&type=template&id=e84add4a&scoped=true"
import script from "./NewYearVideo.vue?vue&type=script&lang=js"
export * from "./NewYearVideo.vue?vue&type=script&lang=js"
import style0 from "./NewYearVideo.vue?vue&type=style&index=0&id=e84add4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84add4a",
  null
  
)

export default component.exports